import React, { useEffect, useState } from 'react'
import TimePicker from 'react-multi-date-picker/plugins/time_picker'
import persian from 'react-date-object/calendars/persian'
import persian_fa from 'react-date-object/locales/persian_fa'
import DatePicker, { DateObject } from 'react-multi-date-picker'
import Toolbar from 'react-multi-date-picker/plugins/toolbar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarDays, faClock } from '@fortawesome/free-solid-svg-icons'

const FurloughSelectTime = ({
    typeFurlough,
    selectedDate,
    setSelectedDate,
    selectedTimeFrom,
    setSelectedTimeFrom,
    selectedTimeTo,
    setSelectedTimeTo,
    organizationWorkingHour,
    handlerMinMaxTime,
}) => {
    const [timeRange, setTimeRange] = useState(null)

    const workingHours = {
        0: {
            // شنبه
            from: organizationWorkingHour.saturdayFrom,
            to: organizationWorkingHour.saturdayTo,
            breakFrom: organizationWorkingHour.saturdayBreakFrom,
            breakTo: organizationWorkingHour.saturdayBreakTo,
        },
        1: {
            // یکشنبه
            from: organizationWorkingHour.sundayFrom,
            to: organizationWorkingHour.sundayTo,
            breakFrom: organizationWorkingHour.sundayBreakFrom,
            breakTo: organizationWorkingHour.sundayBreakTo,
        },
        2: {
            // دوشنبه
            from: organizationWorkingHour.mondayFrom,
            to: organizationWorkingHour.mondayTo,
            breakFrom: organizationWorkingHour.mondayBreakFrom,
            breakTo: organizationWorkingHour.mondayBreakTo,
        },
        3: {
            // سه‌شنبه
            from: organizationWorkingHour.tuesdayFrom,
            to: organizationWorkingHour.tuesdayTo,
            breakFrom: organizationWorkingHour.tuesdayBreakFrom,
            breakTo: organizationWorkingHour.tuesdayBreakTo,
        },
        4: {
            // چهارشنبه
            from: organizationWorkingHour.wednesdayFrom,
            to: organizationWorkingHour.wednesdayTo,
            breakFrom: organizationWorkingHour.wednesdayBreakFrom,
            breakTo: organizationWorkingHour.wednesdayBreakTo,
        },
        5: {
            // پنج‌شنبه
            from: organizationWorkingHour.thursdayFrom,
            to: organizationWorkingHour.thursdayTo,
            breakFrom: organizationWorkingHour.thursdayBreakFrom,
            breakTo: organizationWorkingHour.thursdayBreakTo,
        },
        6: {
            // جمعه
            from: organizationWorkingHour.fridayFrom,
            to: organizationWorkingHour.fridayTo,
            breakFrom: organizationWorkingHour.fridayBreakFrom,
            breakTo: organizationWorkingHour.fridayBreakTo,
        },
    }

    const isClosedDay = (date) => {
        if (!date || !date.weekDay) return true
        const dayOfWeek = date.weekDay.index
        console.log(date, 'date.weekDay.index')
        const dayHours = workingHours[dayOfWeek]
        return !dayHours || !dayHours.from || !dayHours.to
    }

    useEffect(() => {
        if (selectedDate) {
            const dayOfWeek = selectedDate.weekDay.index
            const dayWorkingHours = workingHours[dayOfWeek]

            if (dayWorkingHours?.from && dayWorkingHours?.to) {
                const timeRangeObj = {
                    from: dayWorkingHours.from.slice(0, 5),
                    to: dayWorkingHours.to.slice(0, 5),
                    breakFrom: dayWorkingHours.breakFrom?.slice(0, 5),
                    breakTo: dayWorkingHours.breakTo?.slice(0, 5),
                }
                setTimeRange(timeRangeObj)

                // تنظیم زمان پیش‌فرض
                const [hoursFrom, minutesFrom] = timeRangeObj.from.split(':')
                const defaultTimeFrom = new DateObject({
                    calendar: persian,
                    locale: persian_fa,
                    format: 'HH:mm',
                    hour: parseInt(hoursFrom),
                    minute: parseInt(minutesFrom),
                    second: 0,
                    millisecond: 0,
                })
                setSelectedTimeFrom(defaultTimeFrom)

                // تنظیم زمان پیش‌فرض
                const [hoursTo, minutesTo] = timeRangeObj.to.split(':')
                const defaultTimeTo = new DateObject({
                    calendar: persian,
                    locale: persian_fa,
                    format: 'HH:mm',
                    hour: parseInt(hoursTo),
                    minute: parseInt(minutesTo),
                    second: 0,
                    millisecond: 0,
                })
                setSelectedTimeTo(defaultTimeTo)
            } else {
                setTimeRange(null)
                setSelectedTimeFrom(null)
                setSelectedTimeTo(null)
            }
        }
    }, [selectedDate])

    useEffect(() => {
        handlerMinMaxTime({
            min: timeRange?.from,
            max: timeRange?.to,
            breakFrom: timeRange?.breakFrom,
            breakTo: timeRange?.breakTo,
        })
    }, [timeRange])

    const handleTimeChangeFrom = (newTime) => {
        if (!timeRange || !newTime) return
        setSelectedTimeFrom(newTime)
    }

    const handleTimeChangeTo = (newTime) => {
        if (!timeRange || !newTime) return
        setSelectedTimeTo(newTime)
    }

    console.log(workingHours, 'selectedTimeFrom')

    return (
        <div className="flex flex-col gap-4">
            <div className="w-4/12 m-2 maxLg:w-full">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    تاریخ
                </label>
                <div className="relative">
                    <DatePicker
                        inputMode="none"
                        calendar={persian}
                        locale={persian_fa}
                        value={selectedDate}
                        onChange={setSelectedDate}
                        plugins={[
                            <Toolbar position="bottom" sort={['close']} />,
                        ]}
                        mapDays={({ date }) => ({
                            disabled: isClosedDay(date),
                        })}
                        format="YYYY/MM/DD"
                        className="w-full  bg-white  rounded-xl "
                        style={{
                            width: '100%',
                            height: '100%',
                            padding: '10px',
                            borderRadius: '10px',
                            border: '1px solid #ccc',
                        }}
                    />
                    <FontAwesomeIcon
                        icon={faCalendarDays}
                        className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                    />
                </div>
            </div>

            {selectedDate && timeRange && (
                <div className="my-4 p-4 bg-red-50 border border-red-300 rounded-xl text-sm text-red-800 font-medium shadow-sm space-y-2">
                    <div className="flex items-center space-x-2 rtl:space-x-reverse">
                        <span className="font-semibold">🕒 ساعات کاری:</span>{' '}
                        <span className="!mr-1">
                            از {timeRange.from} تا {timeRange.to}
                        </span>
                    </div>

                    {timeRange.breakFrom && timeRange.breakTo && (
                        <div className="flex items-center space-x-2 rtl:space-x-reverse">
                            <span className="font-semibold">
                                ☕ زمان استراحت:
                            </span>
                            <span className="!mr-1">
                                از {timeRange.breakFrom} تا {timeRange.breakTo}
                            </span>
                        </div>
                    )}
                </div>
            )}

            {typeFurlough === 'hourly' && selectedDate && timeRange && (
                <div className="flex flex-col">
                    <div className="flex maxLg:flex-col">
                        <div className="w-2/12 m-1 maxLg:w-full">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                از ساعت
                            </label>
                            <div className="relative">
                                <DatePicker
                                    inputMode="none"
                                    disableDayPicker
                                    format="HH:mm"
                                    calendar={persian}
                                    locale={persian_fa}
                                    value={selectedTimeFrom}
                                    onChange={handleTimeChangeFrom}
                                    plugins={[
                                        <TimePicker
                                            hideSeconds
                                            minTime={timeRange.from}
                                            maxTime={timeRange.to}
                                        />,
                                    ]}
                                    className="w-full  bg-white  rounded-xl "
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        padding: '10px',
                                        borderRadius: '10px',
                                        border: '1px solid #ccc',
                                    }}
                                />
                                <FontAwesomeIcon
                                    icon={faClock}
                                    className="absolute left-3 top-1/2 transform
                            -translate-y-1/2 text-gray-400 pointer-events-none"
                                />
                            </div>
                        </div>
                        <div className="w-2/12 m-1 maxLg:w-full">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                تا ساعت
                            </label>
                            <div className="relative">
                                <DatePicker
                                    inputMode="none"
                                    disableDayPicker
                                    format="HH:mm"
                                    calendar={persian}
                                    locale={persian_fa}
                                    value={selectedTimeTo}
                                    onChange={handleTimeChangeTo}
                                    plugins={[
                                        <TimePicker
                                            hideSeconds
                                            minTime={timeRange.from}
                                            maxTime={timeRange.to}
                                        />,
                                    ]}
                                    className="w-full  bg-white  rounded-xl "
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        padding: '10px',
                                        borderRadius: '10px',
                                        border: '1px solid #ccc',
                                    }}
                                />
                                <FontAwesomeIcon
                                    icon={faClock}
                                    className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {selectedDate && selectedTimeFrom && selectedTimeTo ? (
                <div className="my-4 p-4 bg-green-50 border border-green-300 rounded-xl text-sm text-green-800 font-medium shadow-sm space-y-2">
                    <div className="flex items-center space-x-2 rtl:space-x-reverse">
                        <span className="font-semibold">
                            📅 تاریخ انتخاب شده:
                        </span>
                        <span className="!mr-1">
                            {selectedDate.format('YYYY/MM/DD')}
                        </span>
                    </div>
                    {typeFurlough === 'hourly' && (
                        <div className="flex items-center space-x-2 rtl:space-x-reverse">
                            <span className="font-semibold">🕒 ساعت:</span>
                            <span className="!mr-1">
                                از {selectedTimeFrom.format('HH:mm')} تا{' '}
                                {selectedTimeTo.format('HH:mm')}
                            </span>
                        </div>
                    )}
                </div>
            ) : (
                <div className="my-4 p-4 bg-red-50 border border-red-300 rounded-xl text-sm text-red-800 font-medium shadow-sm flex items-center space-x-2 rtl:space-x-reverse">
                    <span>⚠️</span>
                    <span className="!mr-1">لطفا تاریخ را انتخاب کنید</span>
                </div>
            )}
        </div>
    )
}
export default FurloughSelectTime
